<template>
  <div class="column column-main is-one-fifth course-list">
    <h1 class="title is-3">Kurser</h1>
    <nav class="panel">
      <p class="panel-tabs">
        <a
          v-for="month in getMonths()"
          :key="month"
          :class="{ 'is-active': selectedMonth == month }"
          @click="selectedMonth = month"
          >{{ months[month] }}</a
        >
      </p>
      <a
        class="panel-block"
        v-for="course in selectedCourses()"
        :class="{
          'is-active is-active-course': selectedCourse._id == course._id,
        }"
        :key="course.id"
        @click="selectCourse(course)"
      >
        {{ course.type }}
        <br />
        {{ course.startDate | formatDate }} -
        {{ course.endDate | formatDate }} | {{ course.time }}

        <p class="nbr">
          {{ course.numberOfBookings }}/{{ course.numberOfParticipants }}
        </p>
      </a>
    </nav>

    <div class="new-course">
      <new-course
        class="new-course-button"
        @reloadCourses="reloadCourses"
      ></new-course>
    </div>
  </div>
</template>

<script>
import NewCourse from "@/components/AdminCourses/NewCourse.vue";
import router from "@/router.js";

export default {
  name: "CourseList",
  props: {
    courses: Array,
  },
  components: {
    NewCourse,
  },
  data: function () {
    return {
      months: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "Maj",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Okt",
        "Nov",
        "Dec",
      ],
      selectedMonth: {},
      selectedCourse: {},
    };
  },
  methods: {
    getMonths() {
      return [
        ...new Set(
          this.courses.map((course) => new Date(course.startDate).getMonth())
        ),
      ].sort();
    },
    selectedCourses() {
      return this.courses
        .filter(
          (course) =>
            new Date(course.startDate).getMonth() == this.selectedMonth
        )
        .sort((a, b) => new Date(a.startDate) - new Date(b.startDate));
    },
    selectCourse: function (course) {
      this.selectedCourse = course;
      router.push({ path: "courses", query: { id: course._id } });
      this.$emit("courseSelected", course);
    },
    reloadCourses: function () {
      this.$emit("reloadCourses");
    },
  },
  created() {
    this.selectedMonth = new Date().getMonth();
  },
  watch: {
    courses: function () {
      var id = this.$route.query.id;

      if (id && this.courses.length > 0) {
        var course = this.courses.filter((course) => course._id == id)[0];
        if (course) {
          this.selectedCourse = course;
          this.$emit("courseSelected", course);
        }
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.nbr {
  margin-left: auto;
}

.is-active-course {
  background-color: hsl(217, 71%, 53%);
  color: white !important;
  border-radius: 10px;
}

.panel {
  border: None;
}

.new-course {
  padding-left: 0.5rem;
  padding-right: 1rem;
  text-align: left;
}

.course-list {
  background-color: hsl(0, 0%, 98%);
}

.panel-block {
  border: None;
  color: hsl(0, 0%, 40%);
}

.panel-block:hover {
  color: hsl(0, 0%, 40%) !important;
  border-radius: 10px;
}

.panel-tabs {
  border: None;
  border-top: None !important;
}

.column-main {
  padding-right: 0.5rem;
  padding-left: 1.25rem;
  box-shadow: inset 0 0 5px 0 #dfdfdf;
}
</style>